import { Pipe, PipeTransform } from '@angular/core';
import { ALL_VIEW_ID, FOLLOWING_VIEW_ID } from '../../core/src/lib/inbox.constants';

@Pipe({
  name: 'viewIcon',
  standalone: false,
})
export class ViewIconPipe implements PipeTransform {
  transform(viewId: string): string {
    switch (viewId) {
      case ALL_VIEW_ID:
        return 'inbox';
      case FOLLOWING_VIEW_ID:
        return 'star';
      default:
        return 'inbox';
    }
  }
}

@Pipe({
  name: 'viewName',
  standalone: false,
})
export class ViewNamePipe implements PipeTransform {
  transform(viewId: string): string {
    switch (viewId) {
      case ALL_VIEW_ID:
        return 'INBOX.VIEWS.ALL_CONVERSATIONS';
      case FOLLOWING_VIEW_ID:
        return 'INBOX.VIEWS.FOLLOWING';
      default:
        return '';
    }
  }
}
